module.exports = __webpack_public_path__ + "img/0adcf44ce90d9caf4aeb01a38f1bc053.0adcf44c.png";